export function paymentReducer(state = "",{
    type,
    payload
}){
    switch(type){
        case "GET_PAYMENTS":
            return payload;
        case "UPDATE_PAYMENTS_LINK":
            let state1 = Object.assign({}, state)
            payload.list.forEach( payID => state1[payID].income_id = payload.income_id )
            return state1;
        case "UPDATE_PAYMENTS_UNLINK":
            let state2 = Object.assign({}, state)
            payload.list.forEach( payID => state2[payID].income_id = "" )
            return state2;
        
        default:
            return state;
    }
}